/**
 * <s-gallery-dots> — mobile swipe indicator for the product gallery. Builds one dot per visible
 * slide of the nearest [data-product-gallery] (colour filtering hides the rest) and highlights the
 * slide in view. Rebuilds on the `gallery:change` event fired by s-colour-gallery.js.
 */
class SGalleryDots extends HTMLElement {
  connectedCallback() {
    const scope = this.closest('s-product-image-zoom') || document;
    this.track = scope.querySelector('[data-product-gallery]');
    this.dotsEl = this.querySelector('[data-dots]');
    this.current = this.querySelector('[data-current]');
    this.total = this.querySelector('[data-total]');
    this.template = this.querySelector('[data-dot-template]');
    if (!this.track || !this.dotsEl || !this.template) return;
    this.onScroll = () => {
      cancelAnimationFrame(this.frame);
      this.frame = requestAnimationFrame(() => this.update());
    };
    this.onChange = () => this.build();
    this.track.addEventListener('scroll', this.onScroll, { passive: true });
    this.track.addEventListener('gallery:change', this.onChange);
    this.build();
  }

  disconnectedCallback() {
    this.track?.removeEventListener('scroll', this.onScroll);
    this.track?.removeEventListener('gallery:change', this.onChange);
  }

  build() {
    const count = [...this.track.children].filter((el) => !el.hidden).length;
    this.hidden = count < 2;
    this.dotsEl.replaceChildren(...Array.from({ length: count }, () => this.template.content.firstElementChild.cloneNode(true)));
    this.dots = [...this.dotsEl.children];
    if (this.total) this.total.textContent = String(count);
    this.update();
  }

  update() {
    if (!this.dots?.length) return;
    const width = this.track.clientWidth || 1;
    const index = Math.min(this.dots.length - 1, Math.max(0, Math.round(Math.abs(this.track.scrollLeft) / width)));
    this.dots.forEach((dot, i) => {
      const active = i === index;
      dot.classList.toggle('w-5', active);
      dot.classList.toggle('w-1.5', !active);
      dot.classList.toggle('opacity-100', active);
      dot.classList.toggle('opacity-30', !active);
    });
    if (this.current) this.current.textContent = String(index + 1);
  }
}

if (!customElements.get('s-gallery-dots')) customElements.define('s-gallery-dots', SGalleryDots);
